export class NotificationConstants {
    public static readonly duration: number = 5000;
}
